import { render } from "./SSOSignOut.vue?vue&type=template&id=7688f40c&scoped=true"
import script from "./SSOSignOut.vue?vue&type=script&lang=js"
export * from "./SSOSignOut.vue?vue&type=script&lang=js"

import "./SSOSignOut.vue?vue&type=style&index=0&id=7688f40c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7688f40c"]])

export default __exports__